// Check user navigator type
export const isMobile: boolean = navigator.userAgent.toLowerCase().match(/(wechat|ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) != null;
